/**
 * ajax请求配置
 */
import axios from 'axios'
import apiURL from './api.js'
// import Qs from 'qs'
import {Message,Loading} from 'element-ui'

// axios默认配置
axios.defaults.timeout = 100000 // 超时时间
axios.defaults.baseURL = apiURL // 默认地址
axios.defaults.headers.post['Content-Type'] = 'application/json'

// 整理数据
axios.defaults.transformRequest = function (data) {
// data = Qs.stringify(data);
  data = JSON.stringify(data)
  return data
}

let loading = null //定义loading变量
//开始 加载loading
let startLoading=()=>{
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
//结束 取消loading加载
let endLoading=()=>{
  loading.close()
}

let needLoadingRequestCount = 0 //声明一个变量
let showFullScreenLoading=()=> {
  
  if (needLoadingRequestCount === 0) { //当等于0时证明第一次请求 这时开启loading
      startLoading()
  }
  needLoadingRequestCount++ //全局变量值++ 
}

let tryHideFullScreenLoading=()=> {
  if (needLoadingRequestCount <= 0) return //小于等于0 证明没有开启loading 此时return
  needLoadingRequestCount-- //正常响应后 全局变量 --
  if (needLoadingRequestCount === 0) {  //等于0 时证明全部加载完毕 此时结束loading 加载
      endLoading()
  }
}





// 路由请求拦截
// http request 拦截器
axios.interceptors.request.use(
  config => {
    console.log(config);
    showFullScreenLoading()
    console.log("---------------");
    // config.data = JSON.stringify(config.data)
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    // config.headers['Authorization'] = token;
    return config
  },
  error => {
    return Promise.reject(error.response)
  })

// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
  response => {
    tryHideFullScreenLoading()
    if (response.data.code == '401') {
      console.log('response.data.resultCode是401');
      // window.location.href = 'http://mnbinggui.mengniu.com.cn/web/login'
      // 返回 错误代码-1 清除ticket信息并跳转到登录页面
      //      cookie.del("ticket")
      //      window.location.href='http://login.com'
    } else {
      return response
    }
  },
  error => {
    tryHideFullScreenLoading()
    // window.location.href = 'http://mnbinggui.mengniu.com.cn/web/login'
    // return Promise.reject(error.response) // 返回接口返回的错误信息
  })

export default axios



// WEBPACK FOOTER //
// ./src/axios/http.js